module.exports = __webpack_public_path__ + "static/media/fz_mthview_pt_BR.7c25e17c.png";